import React, { useEffect, useRef, useMemo } from 'react';
import { createMarkdownRenderer } from '../../lib/preview';
import mermaid from 'mermaid';

interface MarkdownPreviewProps {
  markdown: string;
}

let mermaidInitialized = false;

function initMermaid() {
  if (!mermaidInitialized) {
    mermaid.initialize({
      startOnLoad: false,
      theme: 'default',
      securityLevel: 'loose',
    });
    mermaidInitialized = true;
  }
}

export const MarkdownPreview: React.FC<MarkdownPreviewProps> = ({ markdown }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const md = useMemo(() => createMarkdownRenderer(), []);

  useEffect(() => {
    initMermaid();
  }, []);

  useEffect(() => {
    if (!containerRef.current) return;

    const html = md.render(markdown);
    containerRef.current.innerHTML = html;

    // Process mermaid blocks
    const mermaidBlocks = containerRef.current.querySelectorAll('pre code.language-mermaid');
    if (mermaidBlocks.length > 0) {
      mermaidBlocks.forEach((block, idx) => {
        const code = block.textContent || '';
        const pre = block.parentElement;
        if (!pre) return;

        const div = document.createElement('div');
        div.className = 'mermaid';
        div.id = `mermaid-preview-${idx}-${Date.now()}`;
        div.textContent = code;
        pre.replaceWith(div);
      });

      // Run mermaid rendering
      mermaid.run({
        nodes: containerRef.current.querySelectorAll('.mermaid'),
      }).catch(console.error);
    }
  }, [markdown, md]);

  return (
    <div
      ref={containerRef}
      className="preview-content h-full overflow-auto px-6 py-4"
    />
  );
};
